import { useEffect, useState } from "react";
import { getAuthConfig } from "../auth/api";
import LoadingOverlay from "./components/LoadingOverlay";
import { initAmplify } from "./lib/amplify";
import { loadCspTag } from "./lib/csp";
import Providers from "./providers";
import { getUrlHost } from "./utils";
import AppRoutes from "./Routes";

function App() {
  const [isReady, setIsReady] = useState(false);
  useEffect(() => {
    (async () => {
      try {
        const authConfig = await getAuthConfig();
        window.authConfig = authConfig;

        loadCspTag("default-src", [getUrlHost(authConfig.tokenIssuerUrl)]);
        initAmplify(authConfig);

        setIsReady(true);
      } catch (e) {
        console.error(e);
      }
    })();
  }, []);

  if (!isReady) return <LoadingOverlay />;
  return (
    <Providers>
      <AppRoutes />
    </Providers>
  );
}

export default App;
